/* ==========================================================================
   Kelva — fiche produit : variantes et galerie
   ========================================================================== */

(function () {
  const Kelva = (window.Kelva = window.Kelva || {});
  const settings = Kelva.settings || {};

  function initProduct(scope) {
    (scope || document).querySelectorAll('[data-product-block]').forEach((block) => {
      if (block.dataset.bound) return;
      block.dataset.bound = 'true';

      const dataEl = block.querySelector('[data-variants]');
      if (!dataEl) return;
      let variants = [];
      try {
        variants = JSON.parse(dataEl.textContent);
      } catch (error) {
        return;
      }
      if (!variants.length) return;

      const form = block.querySelector('[data-product-form]');
      const idInput = block.querySelector('[data-variant-id]');
      const priceEl = block.querySelector('[data-variant-price]');
      const compareEl = block.querySelector('[data-variant-compare]');
      const button = block.querySelector('[data-add-button]');
      const inputs = block.querySelectorAll('[data-option-input]');
      const groups = block.querySelectorAll('[data-option-position]');

      function currentOptions() {
        const values = [];
        groups.forEach((group) => {
          const checked = group.querySelector('input:checked');
          const select = group.querySelector('select');
          if (checked) values.push(checked.value);
          else if (select) values.push(select.value);
        });
        return values;
      }

      function findVariant(options) {
        /* Produit à variante unique : aucun sélecteur n'est affiché. */
        if (!groups.length || !options.length) return variants[0];
        return variants.find((variant) =>
          variant.options.every((value, index) => value === options[index])
        );
      }

      function update() {
        const variant = findVariant(currentOptions());

        if (!variant) {
          if (button) {
            button.disabled = true;
            button.textContent = settings.strings.unavailable;
          }
          return;
        }

        if (idInput) idInput.value = variant.id;

        if (priceEl) priceEl.textContent = Kelva.money(variant.price);
        if (compareEl) {
          const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
          compareEl.textContent = onSale ? Kelva.money(variant.compare_at_price) : '';
          compareEl.hidden = !onSale;
        }

        if (button) {
          button.disabled = !variant.available;
          button.textContent = variant.available
            ? settings.strings.addToCart
            : settings.strings.soldOut;
        }

        const sticky = document.querySelector('[data-sticky-atc] [data-sticky-price]');
        if (sticky) sticky.textContent = Kelva.money(variant.price);

        if (variant.featured_media) {
          const target = block.querySelector(`[data-media-id="${variant.featured_media.id}"]`);
          if (target) target.click();
        }

        if (window.history.replaceState && form && groups.length) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url);
        }
      }

      inputs.forEach((input) => input.addEventListener('change', update));
      update();
    });
  }

  function initGallery(scope) {
    (scope || document).querySelectorAll('[data-gallery]').forEach((gallery) => {
      if (gallery.dataset.bound) return;
      gallery.dataset.bound = 'true';
      const main = gallery.querySelector('[data-gallery-main]');
      gallery.querySelectorAll('[data-media-id]').forEach((thumb) => {
        thumb.addEventListener('click', () => {
          gallery.querySelectorAll('[data-media-id]').forEach((t) => t.classList.remove('is-active'));
          thumb.classList.add('is-active');
          const src = thumb.dataset.mediaSrc;
          const img = main.querySelector('img');
          if (img && src) {
            img.style.opacity = '0';
            const next = new Image();
            next.onload = () => {
              img.src = src;
              img.srcset = thumb.dataset.mediaSrcset || '';
              img.alt = thumb.dataset.mediaAlt || '';
              img.style.opacity = '1';
            };
            next.src = src;
          }
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initProduct(document);
    initGallery(document);
  });
  document.addEventListener('shopify:section:load', (event) => {
    initProduct(event.target);
    initGallery(event.target);
  });
})();
